module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.progress != null) ? _c('div', {
    staticClass: "progress-wrap"
  }, [_c(_vm.typeOfSubmission(_vm.submission), {
    key: _vm.progress.id,
    tag: "component",
    staticClass: "progress-preview",
    attrs: {
      "submissions": [_vm.submission]
    }
  }), (_vm.progress.feedback || _vm.progress.diligence) ? _c('div', {
    staticClass: "progress-feedback"
  }, [(_vm.progress.feedback) ? [_c('teacher-feedback', {
    attrs: {
      "feedback": _vm.$store.state.feedback.storage[_vm.progress.feedback],
      "minimal": true
    }
  })] : _vm._e(), (_vm.progress.diligence) ? [_vm._m(0), _c('diligence', {
    attrs: {
      "progress": _vm.progress,
      "readonly": true,
      "showOnlySelected": true
    }
  })] : _vm._e()], 2) : _vm._e()], 1) : _c('span', [_vm._v("Geen voortgang")])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h3', [_c('span', [_vm._v("Beoordeling")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794b1ea3","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/students/Progress.vue
// module id = czDB
// module chunks = 1